import request from '@/utils/request'
import moment from 'moment'

const prefix = '/django_rest/crm'

export default {
  searchTag: (params) => {
    return request.get(`${prefix}/tag/`, { params })
  },
  getTagById: (id) => {
    return request.get(`${prefix}/tag/${id}`)
  },
  createTag: (tag) => {
    return request.post(`${prefix}/tag/`, tag)
  },
  updateTag: (tag) => {
    return request.put(`${prefix}/tag/${tag.id}`, tag)
  },
  deleteTag: (id) => {
    return request.delete(`${prefix}/tag/${id}`, id)
  },
  searchMicrosite: (params) => {
    return request.get(`${prefix}/microsite/`, { params })
  },
  getMicrositeById: (id) => {
    return request.get(`${prefix}/microsite/${id}`)
  },
  createMicrosite: (microsite) => {
    return request.post(`${prefix}/microsite/`, microsite)
  },
  updateMicrosite: (microsite) => {
    return request.put(`${prefix}/microsite/${microsite.id}`, microsite)
  },
  deleteMicrosite: (id) => {
    return request.delete(`${prefix}/microsite/${id}`, id)
  },
  searchCampaign: (params) => {
    return request.get(`${prefix}/campaign/`, { params })
  },
  getCampaignById: (id, params) => {
    return request.get(`${prefix}/campaign/${id}`, { params })
  },
  createCampaign: (campaign) => {
    return request.post(`${prefix}/campaign/`, campaign)
  },
  updateCampaign: (campaign) => {
    return request.put(`${prefix}/campaign/${campaign.id}`, campaign)
  },
  deleteCampaign: (id) => {
    return request.delete(`${prefix}/campaign/${id}`, id)
  },
  getCampaignByUrl: (url) => {
    return request.get(`${prefix}/campaign/page/${url}/`)
  },
  copyMicrosite: (formId, newSite) => {
    return request.post(`${prefix}/microsite/copy/${formId}/`, newSite)
  },
  publishMicrosite: (id, isPublish) => {
    return request.put(`${prefix}/microsite/publish/${id}/`, { is_publish: isPublish })
  },
  getMicrositeByUrl: (url) => {
    return request.get(`${prefix}/microsite/page/${url}/`)
  },
  updateMicrositeConfig: (url, type, config, jobIds) => {
    return request.put(`${prefix}/microsite/page/${url}/`, { page_type: type, config, job_ids: jobIds })
  },
  getCampaignReport: (params) => {
    return request.get(`${prefix}/campaign/report/`, { params })
  },
  searchCampaignNotificationMessage: (params) => {
    return request.get('/django_rest/company/wechat/material/news/', { params })
  },
  searchCampaignNotification: (campaignId, params) => {
    return request.get(`${prefix}/campaign/${campaignId}/notification/`, { params })
  },
  sendCampaignNotification: (campaignId, notification) => {
    return request.post(`${prefix}/campaign/${campaignId}/notification/`, notification)
  },
  exportCampaignReport: (exportData) => {
    return request({
      url: `${prefix}/microsite_campaign_report_export/`,
      method: 'post',
      data: exportData,
      responseType: 'blob'
    })
  },
  createDownloadFile: (response) => {
    const blob = new Blob([response])
    const fileName = `CampaignReport_${moment().format('YYYY-MM-DD HH-mm-ss')}.xlsx`
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE, Edge
      window.navigator.msSaveOrOpenBlob(blob, fileName)
    } else { // Chrome, FF
      const link = document.createElement('a')
      const downUrl = window.URL.createObjectURL(blob)
      link.href = downUrl
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(downUrl)
      document.body.removeChild(link)
    }
  },
  getMicrositeCompanyInfo: (siteId) => {
    return request.get(`${prefix}/microsite/company/info/`, {
      params: {
        short_unique_id: siteId
      }
    })
  },
  getMicrositeCampaignCompanyInfo: (siteId) => {
    return request.get(`${prefix}/microsite/company/info/`, {
      params: {
        short_unique_id: siteId,
        type: 'campaign'
      }
    })
  },
  searchTagTask: (params) => {
    return request.get(`${prefix}/tag/task/`, { params })
  },
  getTagTaskById: (id) => {
    return request.get(`${prefix}/tag/task/${id}/`)
  },
  createTagTask: (task) => {
    return request.post(`${prefix}/tag/task/`, task)
  },
  updateTagTask: (task) => {
    return request.put(`${prefix}/tag/task/${task.id}/`, task)
  },
  deleteTagTask: (id) => {
    return request.delete(`${prefix}/tag/task/${id}/`, id)
  },
  saveCandidateTag: (candidateId, params) => {
    return request.put(`${prefix}/candidate/${candidateId}/tag/`, params)
  },
  deleteCandidateTag: (candidateId, data) => {
    return request.delete(`${prefix}/candidate/${candidateId}/tag/`, { data })
  },
  addCandidateTag: (params) => {
    return request.post(`${prefix}/tag/add/`, params)
  },

  getMicrositeGroupList: (params) => {
    return request.get(`${prefix}/microsite/group/`, { params })
  },
  getMicrositeGroupById: (groupId) => {
    return request.get(`${prefix}/microsite/group/${groupId}`)
  },
  createMicrositeGroup: (params) => {
    return request.post(`${prefix}/microsite/group/`, params)
  },
  updateMicrositeGroup: (params) => {
    return request.put(`${prefix}/microsite/group/${params.id}`, params)
  },
  deleteMicrositeGroup: (groupId) => {
    return request.delete(`${prefix}/microsite/group/${groupId}/`)
  }
}
